import { useTranslation } from "react-i18next";
import type React from "react";
import { NavItem } from "./NavItem";
import { type NavGroupDef, isNavItemActive } from "./nav-model";

/**
 * A labelled group of sidebar nav items (Work / Activity / Manage). The heading
 * is a small uppercase eyebrow in the faint sidebar ink.
 *
 * When `collapsed`, the heading is dropped entirely (no room in the icon
 * rail, and each item's own Tooltip already carries its label).
 */
export function NavGroup({
  group,
  pathname,
  onNavigate,
  collapsed = false,
}: {
  group: NavGroupDef;
  pathname: string;
  onNavigate?: () => void;
  collapsed?: boolean;
}): React.ReactElement {
  const { t } = useTranslation("common");

  return (
    <div className="mb-4">
      {!collapsed && (
        <div className="mb-1.5 px-3 font-semibold text-[10.5px] uppercase tracking-[0.09em] text-[var(--nav-ink-faint)]">
          {t(group.labelKey)}
        </div>
      )}
      <div className="flex flex-col gap-0.5">
        {group.items.map((item) => (
          <NavItem
            key={item.to}
            active={isNavItemActive(item, pathname)}
            collapsed={collapsed}
            item={item}
            onNavigate={onNavigate}
          />
        ))}
      </div>
    </div>
  );
}
